/*
 * Copyright Deskshare, Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

/**
 * Licenses API Service
 */

import { createApi } from "@reduxjs/toolkit/query/react";
import type { License } from "@/types";
import {
  baseQueryWithReauth,
  CACHE_TIMES,
  TAG_TYPES,
} from "@/redux/api-config";

export const licensesApi = createApi({
  reducerPath: "licensesApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: [TAG_TYPES.LICENSES],
  // Licenses change infrequently, cache longer
  keepUnusedDataFor: CACHE_TIMES.LONG,
  endpoints: (builder) => ({
    getLicenseByOrderId: builder.query<License[], string>({
      query: (id) => `licenses/${id}`,
      providesTags: (_result, _error, id) => [
        { type: TAG_TYPES.LICENSES, id },
        { type: TAG_TYPES.LICENSES, id: "LIST" },
      ],
      // Individual licenses can be cached longer
      keepUnusedDataFor: CACHE_TIMES.STABLE,
    }),
    getLicenses: builder.query<License[], void>({
      query: () => "licenses",
      providesTags: (result) =>
        result
          ? [
              ...result.map((license) => ({
                type: TAG_TYPES.LICENSES,
                id: license.ActivationKey,
              })),
              { type: TAG_TYPES.LICENSES, id: "LIST" },
            ]
          : [{ type: TAG_TYPES.LICENSES, id: "LIST" }],
    }),
  }),
});

export const { useGetLicenseByOrderIdQuery, useGetLicensesQuery } = licensesApi;
